import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { signupUser } from '../services/authService';
import { toast } from 'react-toastify';

const SignupForm = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    
    try {
      await signupUser(username, password, name);
      
      // Show success toast
      toast.success('Account created successfully!');
      
      navigate('/home');
      
    } catch (error) {
      setError(error.message || 'Signup failed. Please try again.');
      toast.error(error.message || 'Signup failed. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form 
      className="bg-white rounded-xl p-6 shadow-lg border border-gray-100 transition-transform duration-300 ease-out origin-center hover:-translate-y-1 hover:scale-[1.01] hover:shadow-xl hover:border-gray-200 relative"
      onSubmit={handleSubmit}
    >
      <div className="mb-4 text-center">
        <div className="inline-block">
          <img src="/a3-logo.png" alt="A3" className="h-10 mx-auto object-contain" />
          <p className="mt-0.5 text-xs text-primary-light italic">Assist, Augment, Autonomize</p>
        </div>
      </div>
      
      <h2 className="text-xl font-bold text-primary text-center mb-5">Create Account</h2>
      
      <div className="mb-4">
        <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
          Full Name
        </label>
        <input
          id="name"
          type="text"
          placeholder="Enter your full name"
          value={name}
          onChange={e => setName(e.target.value)}
          required
          disabled={isLoading}
          className="w-full py-2.5 px-3 border border-gray-300 rounded-md text-sm transition-all focus:outline-none focus:border-black focus:shadow-sm focus:ring-2 focus:ring-blue-200 focus:-translate-y-0.5"
        />
      </div>
      
      <div className="mb-4">
        <label htmlFor="username" className="block text-sm font-medium text-gray-700 mb-1">
          Username
        </label>
        <input
          id="username"
          type="text"
          placeholder="Choose a username"
          value={username}
          onChange={e => setUsername(e.target.value)}
          required
          disabled={isLoading}
          className="w-full py-2.5 px-3 border border-gray-300 rounded-md text-sm transition-all focus:outline-none focus:border-black focus:shadow-sm focus:ring-2 focus:ring-blue-200 focus:-translate-y-0.5"
        />
      </div>
      
      <div className="mb-4">
        <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1">
          Password
        </label>
        <input
          id="password"
          type="password"
          placeholder="Create a password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          required
          disabled={isLoading}
          className="w-full py-2.5 px-3 border border-gray-300 rounded-md text-sm transition-all focus:outline-none focus:border-black focus:shadow-sm focus:ring-2 focus:ring-blue-200 focus:-translate-y-0.5"
        />
      </div>
      
      {error && (
        <div className="bg-red-50 text-red-700 p-2.5 rounded-md mb-5 text-sm">
          {error}
        </div>
      )}
      
      <button 
        type="submit" 
        className="w-full py-2.5 bg-primary text-white border-none rounded-md text-sm font-medium cursor-pointer transition-colors hover:bg-primaryLight flex justify-center items-center relative overflow-hidden"
        disabled={isLoading}
      >
        {isLoading ? (
          <span className="inline-block w-5 h-5 border-2 border-white/30 rounded-full border-t-white animate-spin"></span>
        ) : (
          'Sign Up'
        )}
      </button>
      
      <div className="mt-5 text-center text-sm text-gray-600">
        <p>Already have an account? <Link to="/a3-login" className="text-primary font-medium hover:text-primaryLight hover:underline transition-colors">Login</Link></p>
      </div>
    </form>
  );
};

export default SignupForm;